import { FaHome, FaUser, FaTimes } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";

export default function AdminSidebar({ isOpen, onClose }) {

  const location = useLocation(); // get current path

  return (
    <div className={`sidebar ${isOpen ? "active" : ""}`}>

      <div className="sidebar-header">
        <div className="logo">Admin Panel</div>
        <FaTimes className="close-btn" onClick={onClose} />
      </div>

      <ul className="menu">

        {/* Dashboard */}
        <li className={location.pathname === "/admin-dashboard" ? "active" : ""}>
          <Link to="/admin-dashboard" className="menu-link">
            <div className="icon-box">
              <FaHome />
            </div>
            <span style={{ color: "white" }}>Dashboard</span>
          </Link>
        </li>

        {/* Manage Company */}
        <li className={location.pathname === "/admin/companies" ? "active" : ""}>
          <Link to="/admin/companies" className="menu-link">
            <div className="icon-box">
              <FaUser />
            </div>
            <span style={{ color: "white" }}>Manage Company</span>
          </Link>
        </li>

        {/* User */}
        <li className={location.pathname === "/admin-user" ? "active" : ""}>
          <Link to="/admin-user" className="menu-link">
            <div className="icon-box">
              <FaUser />
            </div>
            <span style={{ color: "white" }}>User</span>
          </Link>
        </li>

      </ul>
    </div>
  );
}